<template>
    <div class="table-responsive p-2">
        <el-table border :data="this.data" @expand-change="loadChild" lazy class="el-table-css" style="width: 100%">
            <el-table-column type="expand">
                <template #default="props">
                    <sub-table @open-dialog="OpenDialog" :type="type" :refindex="this.sub.refindex"
                        :constindex="this.sub.constindex" :id="props.row.tmplId"></sub-table>

                </template>
            </el-table-column>
            <el-table-column width="43">
                <template #default="scope">
                    <el-button class="edit-btn" @click="this.$emit('open-dialog', null, true, scope.row, 'PROGRAM')"
                        style="color: #4db2e5; padding: 0 !important;" :icon="Edit" text />
                </template>
            </el-table-column>
            <el-table-column prop="tmplName" label="Grup adı" />
            <el-table-column width="43">
                <template #default="scope">
                    <el-popover style="max-width: 1000px !important;" :width="null" placement="right-start" title="Info"
                        trigger="hover">
                        <template #reference>
                            <el-button type="default"  style="padding: 0 !important;" :icon="InfoFilled"  text />
                        </template>
                        <template #default>
                            <div>
                                Daxil olunub &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ scope.row.created }} <br>
                                Düzəliş
                                olunub &nbsp;&nbsp;&nbsp; {{ scope.row.updated }}
                            </div>
                        </template>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column width="43">
                <template #default="scope">
                    <el-button type="danger"  style="padding: 0 !important;" :icon="Delete"  class="edit-btn" @click="DeleteItem(scope.row)" text />
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import {
    Delete,
    Edit,
    InfoFilled
} from "@element-plus/icons-vue";
import useValidate from '@vuelidate/core';
import SubTable from "./SubTable.vue";

export default {
    props: {
        data: Array,
        refindex: Number,
        constindex: Number
    },
    components: { 
        SubTable
    },
    data() {
        return {
            hovered: false,
            Edit,
            InfoFilled,
            v$: useValidate(),
            Delete,
            tmplId: null,
            alert: false,
            hoveredRefresh: false,
            sub: {
                constindex: null,
                refindex: 0
            },
        }
    },
    watch: {
        refindex() {
            if (this.id == this.sub.constindex) {
                this.sub.refindex = this.sub.refindex + 1
            }
        }
    },
    methods: {
        OpenDialog(index, edit, object, type) {
            this.sub.constindex = index
            this.id = index
            this.type = type
            this.$emit('open-dialog', index, edit, object, type)
        },
        async DeleteItem() {
             //None
        }
    }
}
</script>